import { FilePdf } from "@phosphor-icons/react";
import { CircleNotch } from "@phosphor-icons/react";
import { Button, ButtonProps } from "@reactive-resume/ui";
import { forwardRef } from "react";

import usePdfOutput from "@/client/hooks/use-pdf-output";
import { useResumeStore } from "@/client/stores/resume";

const PdfDownloadButton = forwardRef<HTMLButtonElement, ButtonProps>((_props, ref) => {
  // const [loading, setLoading] = useState(false);
  const resumeData = useResumeStore((state) => state.resume);

  const { loading, output } = usePdfOutput();

  const onPrint = async () => {
    await output(resumeData);
  };

  return (
    <Button
      ref={ref}
      size="icon"
      variant="ghost"
      disabled={loading}
      className="rounded-none"
      onClick={() => onPrint()}
    >
      {loading ? <CircleNotch className="animate-spin" /> : <FilePdf />}
    </Button>
  );
});

export default PdfDownloadButton;
